import { OwnStayIngredient } from '@apps/main/modules/recipe/ingredients/ownStayIngredient';

import { DESTINATION_PRODUCTS_PREFIX } from '../constants';
import { ActivitySerializer } from '../../activitiySerializer';
import type { DeserializedStayConstraintText } from '../deserializeStay';
import {
  deserializeNumberOfNights,
  deserializeStayConstraintText,
  deserializeTransportType,
} from '../deserializeStay';

import { OWN_STAY_INGREDIENT_SUFFIX, PROPS_PREFIX } from './constants';

export function deserializeOwnStay(value: string): OwnStayIngredient {
  const { constraintText, destinationProducts, numberOfNights, transportType } =
    deserializeIngredientParameters(value);

  const { displayText, searchTerm } = deserializeConstraintText(constraintText);

  const result = new OwnStayIngredient(searchTerm);
  if (displayText) {
    result.displayText = displayText;
  }

  destinationProducts.forEach((product) => {
    result.subIngredients.push(
      ActivitySerializer.deserialize(product, result.ingredientId)
    );
  });

  result.numberOfNights = deserializeNumberOfNights(numberOfNights);

  result.transportTypeToBeReached = deserializeTransportType(transportType);

  return result;
}

export interface SerializedOwnStayParameters {
  constraintText: string;
  destinationProducts: string[];
  numberOfNights: string;
  transportType: string;
}

export function deserializeIngredientParameters(
  value: string
): SerializedOwnStayParameters {
  const sanitizedValue = decodeURIComponent(value.replace(/\+/g, ' ')).replace(
    OWN_STAY_INGREDIENT_SUFFIX,
    ''
  );

  const destinationProductsIndex = sanitizedValue.indexOf(
    DESTINATION_PRODUCTS_PREFIX
  );

  const propsIndex = sanitizedValue.indexOf(PROPS_PREFIX);

  const constraintTextEndIndex =
    destinationProductsIndex !== -1 ? destinationProductsIndex : propsIndex;

  const constraintText = sanitizedValue.slice(0, constraintTextEndIndex);

  const destinationProducts = sanitizedValue
    .slice(destinationProductsIndex, propsIndex)
    .split(DESTINATION_PRODUCTS_PREFIX)
    .filter(Boolean);

  const props = sanitizedValue.slice(propsIndex).replace(PROPS_PREFIX, '');

  const numberOfNights = props.slice(0, 2);

  const transportType = props.slice(2);

  return {
    constraintText,
    destinationProducts,
    numberOfNights,
    transportType,
  };
}

export function deserializeConstraintText(
  constraintText: string
): DeserializedStayConstraintText {
  return deserializeStayConstraintText(constraintText);
}
